import {useState} from "react";
import {Button, MenuItem, TextField} from "@mui/material";
import {ElevationApp} from "../../ElevationApp";
import {MdFrameProfileType} from "../../model/frame/MdFrameSpec";
import {FrameProfileScene} from "../../scenes/frameProfile/FrameProfileScene";
import {allHandings} from "../../../../quote/openings/QuoteOpenings";

// re-exported from Helpers (co-located with getProfileObj) for the existing debug
// importers; new code should import it from scenes/frameProfile/Helpers directly.
import {supportedProfiles} from "../../scenes/frameProfile/Helpers";
export {supportedProfiles};

const leafOptions = [{value: "active", label: "Active"}, {value: "inactive", label: "Inactive"}];

export function FrameProfileCtrls(props: {
    app: ElevationApp
}) {
    const spec = props.app.frameSpec;

    const [profile, setProfile] = useState<MdFrameProfileType>(spec?.profile || "STD");
    const [handing, setHanding] = useState<string>(spec?.handing || "");
    const [leaf, setLeaf] = useState<"active" | "inactive">("active");

    const apply = () => {
        const elev = props.app;

        elev.resetFrameSpec();
        elev.frameSpec.profile = profile;
        elev.frameSpec.handing = handing;

        elev.draw.showScene(new FrameProfileScene(elev, leaf === "active"));
    };

    return (
        <>
            <TextField
                select
                size="small"
                label="Frame Profile"
                value={profile}
                onChange={e => setProfile(e.target.value as MdFrameProfileType)}
            >
                {supportedProfiles.map(p => (
                    <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
            </TextField>

            <TextField
                select
                size="small"
                label="Handing"
                value={handing}
                onChange={e => setHanding(e.target.value)}
            >
                <MenuItem value="">(none)</MenuItem>
                {allHandings.map(h => (
                    <MenuItem key={h.value} value={h.value}>{h.display}</MenuItem>
                ))}
            </TextField>

            <TextField
                select
                size="small"
                label="Leaf"
                value={leaf}
                onChange={e => setLeaf(e.target.value as "active" | "inactive")}
            >
                {leafOptions.map(o => (
                    <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
            </TextField>

            <Button variant="contained" size="small" onClick={apply}>Apply</Button>
        </>
    );
}
